export const translationLivechat_da_case = {
  livechatCaseCreate: "Opret sag",
  livechatCaseDialogTitle: "Opret sag",
  livechatCaseDialogDescription:
    "Sender denne chat på mail, på samme måde som den valgte kontaktformular sender en henvendelse.",
  livechatCaseTopic: "Emne",
  livechatCaseTopicPlaceholder: "Vælg et emne",
  livechatCaseNote: "Note til sagen (valgfri)",
  livechatCaseNotePlaceholder: "Hvad skal der ske med sagen?",
  livechatCaseIncludesTranscript: "Chattens samtaleforløb sendes med i sagen.",
  livechatCaseSubmit: "Opret sag",
  livechatCaseSubmitting: "Opretter sag...",
  livechatCaseCancel: "Annuller",
  livechatCaseCreated: "Sag oprettet",
  livechatCaseCreatedDescription: "Sendt til {recipient}",
  livechatCaseFailed: "Sagen kunne ikke oprettes. Prøv igen.",
};
